<template>
  <div class="view">
    <!-- 遮罩层 -->
    <div class="shade-top" :class="searchBarFixed == true ? 'opacity_none' :''"></div>
    <!-- 版心 -->
    <div class="wrap">
      <!-- 左侧logo -->
      <router-link class="index" to="/">
        <img src="../../assets/images/logo.png">
      </router-link>
      <!-- 右侧列表 导航 -->
      <div class="right-nav">
        <div>
            <ul class="nav_box">
              <li 
              @mouseenter="checkout()" 
              @mouseleave="clos()"
              >
              <router-link to="/skill" class="router_nav">产品方案</router-link>
              <div class="line_nav" v-show="isShow"></div>
              </li>
			        <li><router-link to="/news" class="router_nav">新闻中心</router-link></li>
			        <li><router-link to="/about" class="router_nav">关于我们</router-link></li>
			        <li><router-link to="/serve" class="router_nav">服务支持</router-link></li>
            </ul>
            <ul class="top_Nav" @mouseenter="checkout()" @mouseleave="clos()" v-show="isShow">
                <li class="list_Nav">
                  <router-link to="/skill" class="router_link">核心技术</router-link>
			            <router-link to="/product" class="router_link">核心产品</router-link>
                  <router-link to="/client" class="router_link">方案案例</router-link>
			            <!-- <router-link to="/solve" class="router_link">解决方案</router-link>
			            <router-link to="/client" class="router_link">客户案例</router-link> -->
                </li>
                
                <!-- <div class="top_Nav"
                    v-for="(list,index) in twoList" 
                    :key="index" 
                    v-show="isShow"
                    >{{list.name}}</div> -->
            </ul>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "my-header",
  data() {
    return {
      isShow: false,
      searchBarFixed: true,
      show: true
    };
  },

  methods: {
      checkout() {
          this.isShow = true;
      },
      clos() {
          this.isShow = false;
      },


      handleScroll () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop >= 200) {
            this.searchBarFixed = true
        }else {
          this.searchBarFixed = false
        }
      }

  },
  
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  }
};
</script>

<style>
/* 总视图宽度 */
.view {
  height: 80px;
  width: 100%;
  position: fixed;
  /* background: #000000; */
  border-bottom: 1px solid #666666;
  z-index: 1000;
}
/* 版心 */
.wrap {
  width: 1200px;
  margin: 0 auto;
}
/* logo图标 */
.wrap img {
  float: left;
  position: absolute;
  top: 14px;
}
/* 右侧导航 */
.router_nav {
  display: block;
  color: #ffffff;
  font-size: 18px;
  font-family: "MicrosoftYaHei";
}

.right-nav {
  width: 520px;
  float: right;
  /* margin-top: 37px; */
}
.top_Nav {
  font-size: 18px;
  font-family: "MicrosoftYaHei";
  margin-left: -40px; 
  margin-top: 29px;
  /* list-style: none; */
}

.nav_box {
  width: 520px;
  height: 50px;
  position: relative;
  top: 27px;
}
.nav_box li {
  list-style: none;
  float: left;
  width: 112px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  margin-left: 18px;
}

.nav_box li:hover {
  background: #303030;
}

/* 下划线 */
.line_nav {
    height: 3px;
    width: 75px;
    background: #ffffff;
    margin-top: 12px;
    opacity: 0;
}


.active {
    opacity: 0;
}
.unactive {
    opacity: 1;
}

.top_Nav li {
    float: left;
    margin-left: 58px;
    position: relative;
}
/* 遮罩层 */
.shade-top {
  width: 100%;
  height: 80px;
  background: #000000;
  position: fixed;
  opacity: 0.2;
    /* visibility: hidden; */
}

/* 卷去距离透明度 */
.opacity_none {
  opacity: 1;
  background: #282830;
}


/* 路由导航 */
.router_link {
    color: #ffffff;
    display: block;
    margin-top: 10px;
    /* margin-left: 5px; */
}

.list_Nav {
    height: 141px;
    width: 112px;
    background: #303030;
    list-style: none;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/cuscom/header.vue